import { useState, useEffect } from "react";
import { Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";

export default function MaestraOpcionesToolPanel({ api, onEditarMaestra }) {
    const [selectedRows, setSelectedRows] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!api) return;
        const updateSelection = () => setSelectedRows(api.getSelectedRows());
        api.addEventListener("selectionChanged", updateSelection);
        return () => api.removeEventListener("selectionChanged", updateSelection);
    }, [api]);

    const getSelectedRow = () => selectedRows[0];
    const selectedId = getSelectedRow() ? getSelectedRow().mr_id : "—";

    const handleEditarMaestra = () => {
        const row = getSelectedRow();
        if (!row) return;
        onEditarMaestra(row);
    };

    const handleEditMaster = () => {
        //navigate("/exporter");
        window.open("/exporter", "_blank");
    }
    
    const handleEditarJudicial = () => {
        alert("Hello World (Editar Tabla Judicial)");
    };
    const handleVerResumenIA = () => {
        alert("Hello World (Ver Resumen IA)");
    };

    return (
        <div className="flex flex-col gap-2 p-3">
            <h3 className="font-semibold">Options</h3>
            <div className="text-xs text-gray-500 mb-2">Row ID selected: <span className="font-mono">{selectedId}</span></div>
            {/* <Button size="sm" color="primary" onPress={handleEditarMaestra} isDisabled={selectedRows.length === 0}>
                Modify Data
            </Button> */}
            <Button size="sm" color="primary" onPress={handleEditMaster}>
                Ver y editar registros
            </Button>
            {/*<Button size="sm" color="secondary" onPress={handleEditarJudicial}>*/}
            {/*    Editar Tabla Judicial*/}
            {/*</Button>*/}
            {/*<Button size="sm" color="warning" onPress={handleVerResumenIA}>*/}
            {/*    Ver Resumen IA*/}
            {/*</Button>*/}
            {/*<Button size="sm" color="warning" onPress={handleVerResumenIA}>*/}
            {/*    Ver Resumen IA*/}
            {/*</Button>*/}
        </div>
    );
} 